module.exports = __webpack_public_path__ + "static/img/jiqi-txt1.da8e8a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/page-one/img/jiqi-txt1.png
// module id = 1cci
// module chunks = 0